import React from 'react';

export const QA: React.FC = () => {
  const faqs = [
    {
      question: "When is the RSVP deadline?",
      answer: "Please RSVP by 1st April."
    },
    {
      question: "What if I have a dietary restriction or allergy?",
      answer: "Please let us know when completing your RSVP of any dietary requirements that are required."
    },
    {
      question: "I require accommodation, is there accommodation available on site?",
      answer: "Unfortunately accommodation is limited on site, please contact us to clarify if you have a room allocated. We have provided a list of nearby hotels a short taxi journey away."
    },
    {
      question: "Can we take pictures during the wedding?",
      answer: "Yes! Please take photos during the day however, refrain from taking photos during the ceremony as there will be a photographer/videographer present."
    },
    {
      question: "We are staying in Enterkine - What are the check-in and check-out times?",
      answer: "Check in will be available from 2.00pm after the ceremony. Check out is 11.00am the next day."
    },
    {
      question: "What time is breakfast served at Enterkine the next day?",
      answer: "For guests staying at Enterkine, breakfast will be served the following morning in the restaurant at 8.30am - 10.00am."
    },
    {
      question: "I require a taxi, do you know of any local taxi companies?",
      answer: "Enterkine have provided three reputable companies, if required we advise booking them in advance:\nAyr Premier Taxis - 01292 404040\nStreamline - 01292 261010\nThistle Cabs - 01292 260000"
    },
    {
      question: "I have a question not answered here; how do I contact you?",
      answer: "If you have any questions, please contact us by text/call:\nHeather: 07585 956437\nJordan: 07456 055180"
    }
  ];

  return (
    <div className="py-24 max-w-4xl mx-auto px-6">
      <div className="text-center mb-16">
        <h2 className="font-serif-display text-4xl md:text-5xl mb-4 text-black">Q&A</h2>
        <p className="text-sm tracking-[0.3em] text-[#8E806A] font-medium uppercase opacity-70">Information for Guests</p>
      </div>

      <div className="grid gap-12">
        {faqs.map((faq, index) => (
          <div key={index} className="border-l-2 border-[#F5F2ED] pl-8 relative">
            <div className="absolute -left-[5px] top-0 w-2 h-2 rounded-full bg-[#D4C4A8]" />
            <h4 className="font-serif-display text-xl md:text-2xl text-black mb-3 italic">
              {faq.question}
            </h4>
            <div className="text-gray-600 font-light leading-relaxed whitespace-pre-line">
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};